import React from "react";
import Component from "@/components/ui/underline-hero-section";

export default function Demo() {
  const onSignIn = () => {
    window.location.href = "/signin";
  };

  const onTryForFree = () => {
    window.location.href = "/signin";
  };

  return (
    <Component
      brand="Scenechat"
      onSignIn={onSignIn}
      onTryForFree={onTryForFree}
    />
  );
}
